import React, { useEffect } from 'react'
import { Modal } from 'components'
import { loadScript } from 'services/utils/common'
import { func, shape, string } from 'prop-types'
import { setPerimeterXWindow, unsetPerimeterXWindow } from 'services/utils/storage'
import { PERIMETERX_MSG } from 'services/utils/constants/validations'

const PerimeterXModal = ({ title, perimeterXResponse, onCaptchaSuccess }) => {
  useEffect(() => {
    setPerimeterXWindow(perimeterXResponse)
    // eslint-disable-next-line no-underscore-dangle
    window._pxOnCaptchaSuccess = (isValid) => {
      if (isValid) {
        onCaptchaSuccess()
      }
    }

    if (perimeterXResponse.blockScript) {
      loadScript(`${perimeterXResponse.blockScript}`)
    }

    return () => unsetPerimeterXWindow()
  }, [])

  return (
    <div data-testid='perimeterXmodal'>
      <Modal title={title}>
        <React.Fragment>
          <h4>
            {PERIMETERX_MSG}
          </h4>
          <div id="px-captcha" />
        </React.Fragment>
      </Modal>
    </div>)
}

PerimeterXModal.propTypes = {
  title: string.isRequired,
  perimeterXResponse: shape({ blockScript: string }).isRequired,
  onCaptchaSuccess: func.isRequired,
}

export default PerimeterXModal
